module.exports = __webpack_public_path__ + "static/img/2.f97527f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/landing/2.png
// module id = Zuxj
// module chunks = 36